import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import axios from 'axios';
import {API_URL,BASE_URL_RECURSOS} from '../../../constants';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import ModalFile from '../../Partials/ModalFile';
import {showModalPageClass, hideModalPageClass, showLoader, hideLoader, setTestData, setDataForm, setTextInputLongitud, cleanDataForm} from '../../../functions';
import $ from 'jquery';

export default class FichaProductoCertificados extends Component {

    constructor(props)
	{
        super(props);
    }

    state = {
        ficha_producto_certificados_path: 'ficha_producto_certificados',
        certificados : [],
        actionForm: "",
        guardando: false,
        fichaProductoCertificacion: {}
    }

    onSelectArchivo(fileName, fileData, fieldName, fieldNameData){
        let fichaProductoCertificacion = {... this.state.fichaProductoCertificacion};

        document.getElementById(fieldName).value = fileName;
        
        fichaProductoCertificacion[fieldName] = fileName;
        fichaProductoCertificacion[fieldNameData] = fileData;

        this.setState({
            fichaProductoCertificacion
        });

        hideModalPageClass(`div${fieldName}Upload`);
    }

    showModalFile = (clase = "") => {
        showModalPageClass(clase);
    }

    render() {
        return (
            <div>
                 <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de Configuración General
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Ficha Producto</span>
                        <span> / Certificados</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Certificados
                </div>
                <div className="divSector_Panel">
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                            <tbody>
                                <tr>
                                    <th>N°</th>
                                    <th>Título</th>
                                    <th>Imagen Alt</th>
                                    <th>Imagen</th>
                                    <th width={"100"}>Acciones</th>
                                </tr>
                                {
                                    this.state.certificados.length > 0 ? 
                                    
                                    this.state.certificados.map((item, index) => (
                                        <tr key={`certificados-${item.id}`}>
                                            <td>{index + 1}</td>
                                            <td>{item.titulo}</td>
                                            <td>{item.imagenAlt}</td>
                                            <td><a href={`${BASE_URL_RECURSOS}${this.state.ficha_producto_certificados_path}/${item.imagen}`} target="_blank" alt="Ver Imagen">Ver Imagen</a></td>
                                            <td>
                                                <div className="divBtnAcciones">
                                                    <a href="#" className="btnPageModuloEditar" onClick={(event) => this.editarCertificado(event, item)}/>
                                                    <a href="#" className="btnPageModuloEliminar aEliminarMenu2"/>
                                                    <div className="c_divAlertaCapa">
                                                        <div className="divAlertaCapa">
                                                            <div className="divAlerta">
                                                                <h2>&iquest;Seguro de eliminar?</h2>
                                                                <div className="divAlertaBtn">
                                                                    <a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(event, item)}>ACEPTAR</a>
                                                                    <a href="#" className="btnAlertaCancelar">CANCELAR</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                    :

                                    (
                                        <tr>
                                            <td colSpan="6" className="tdSinResultados">
                                                No se encontró resultados.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <div className="divContenedorBtn_Glosario">
                            <a href="" className="btnAddPalabraGlosario btnActivo" id="btnCreateGlosario" onClick={(e) => this.showCrearCertificado(e)}>AGREGAR </a>
                            <a href="" className="btnPrevAddPalabraGlosario" onClick={(event) => this.regresarFichaProducto(event)}>VOLVER</a>
                        </div>
                        <div id="containerForm" style={{display:"none"}}>
                            <div className="divGlosario">
                                <h2>Formulario Certificado</h2>
                                <div className="containerFormCreate">
                                    <div className="divWrapperGlosario2">
                                        <div className="divAddPalabraGlosario">
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Título" id='Titulo' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudTitulo"></span>
                                            </div>
                                            <div className="txtFile x-1">
                                                <input type="text" placeholder="Imagen Alt" id='ImagenAlt' maxLength={255} className="data-test data-form"/>
                                                <span id="longitudImagenAlt"></span>
                                            </div>
                                            <div className="x-1 relative">
                                                <span className="subirImagen" onClick={() => this.showModalFile("divImagenUpload")}/>
                                                <input type="text" placeholder="Imagen" id="Imagen" readOnly={true} />
                                                <br />
                                            </div>
                                        </div>
                                        <div className="divContenedorBtn_Glosario">
                                            <input type="hidden" id="Id" className="data-form"/>
                                            <a href="" className="btnAddPalabraGlosario btnActivo" onClick={(event) => this.guardarForm(event)}>{this.state.actionForm == "G" ? "GUARDAR" :  "ACTUALIZAR"}</a>
                                            <a href="#" className="btnPrevAddPalabraGlosario" onClick={(event) => this.cancelarForm(event)}>CANCELAR</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <ModalFile class={"divImagenUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "Imagen", "ImagenData")} tipo="image"/>
            </div>
        )
    }

    getCertificados(){
        showLoader();

        const url = `${API_URL}FichaProductoCertificacionesUX/ObtenerPorProductoCodigo?productoCodigo=${this.props.match.params.id}`;
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                
                this.setState({ 
                    certificados: data.result.data
                });
            })
            .catch(error => {
                hideLoader();
                toast.error('Error al listar');
            });
    }

    regresarFichaProducto(e) {
        e.preventDefault();

        const {history: {push}} = this.props;
        push('/ficha-producto');
    }  

    eliminarRegistro = (event, entity) => {
        event.preventDefault();

        const url = `${API_URL}FichaProductoCertificacionesUX/Eliminar?id=` + entity.id ;
        const me = this;

        axios.post(url, {}, { 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data)=> {
            
            me.setState({ guardando:false });
            
            if(data.data.result.status){
                toast.success('Certificado Eliminado.');
                this.getCertificados();
                $("#containerForm").fadeOut();
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            me.setState({ guardando:false });
        });
    }

    editarCertificado = (event, item) => {
        event.preventDefault();

        document.getElementById('Id').value = item.id;
        document.getElementById('Titulo').value = item.titulo;
        document.getElementById('Imagen').value = item.imagen;

        let fichaProductoCertificacion = {... this.state.fichaProductoCertificacion};
        
        fichaProductoCertificacion["Imagen"] = item.imagen;
        fichaProductoCertificacion["ImagenData"] = '';

        this.setState({
            fichaProductoCertificacion
        });
        
        this.setState({
            actionForm: "U"
        });

        $("#containerForm").fadeIn();
    }

    showCrearCertificado = (event) => {
        event.preventDefault();

        cleanDataForm();

        this.setState({
            actionForm: "G"
        });

        document.getElementById('Id').value = "0";
        document.getElementById('Imagen').value = "";

        $("#containerForm").fadeIn();
    }

    guardarForm = (e) => {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = this.state.actionForm == "G" ? `${API_URL}FichaProductoCertificacionesUX/Insertar` : `${API_URL}FichaProductoCertificacionesUX/Actualizar`;
            
            let fichaProductoCertificacion = this.state.fichaProductoCertificacion;
            fichaProductoCertificacion["ProductoCodigo"] = this.props.match.params.id;
            
            setDataForm(fichaProductoCertificacion);
    
            axios.post(url, JSON.stringify(JSON.stringify(fichaProductoCertificacion)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                
                me.setState({ guardando:false });
                
                if(data.data.result.status){
                    toast.success(this.state.actionForm == "G" ? 'Certificado Agregado.' : 'Certificado Actualizado.');
                    this.getCertificados();
                    $("#containerForm").fadeOut();
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    cancelarForm = (e) => {
        e.preventDefault();

        $("#containerForm").fadeOut();
    }
	
    componentDidMount()
	{
        this.getCertificados();

        setTextInputLongitud(['Titulo', 'ImagenAlt']);
    }
}

